var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#DF7C2C",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F1CE6B",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/comments/comments",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3977606,4 L7.59904026,4 C5.61456945,4 4,5.61456945 4,7.59904026 L4,10.3982938 C4,12.3157825 5.50719808,13.8877633 7.39909358,13.9919355 L7.39909358,15.6602906 C7.39909358,15.8476406 7.55185284,16 7.73960277,16 C7.82937883,16 7.91435617,15.9644095 7.97853906,15.9002266 L8.35363903,15.5251266 C9.33857638,14.5399893 10.6484271,13.997334 12.0416556,13.997334 L12.3977606,13.997334 C14.3822314,13.997334 15.9968009,12.3827646 15.9968009,10.3982938 L15.9968009,7.59904026 C15.9968009,5.61456945 14.3822314,4 12.3977606,4 Z M7.39909358,9.79845375 C6.9580112,9.79845375 6.59930685,9.4397494 6.59930685,8.99866702 C6.59930685,8.55758464 6.9580112,8.1988803 7.39909358,8.1988803 C7.84017595,8.1988803 8.1988803,8.55758464 8.1988803,8.99866702 C8.1988803,9.4397494 7.83997601,9.79845375 7.39909358,9.79845375 Z M9.99840043,9.79845375 C9.55731805,9.79845375 9.1986137,9.4397494 9.1986137,8.99866702 C9.1986137,8.55758464 9.55731805,8.1988803 9.99840043,8.1988803 C10.4394828,8.1988803 10.7981872,8.55758464 10.7981872,8.99866702 C10.7981872,9.4397494 10.4392829,9.79845375 9.99840043,9.79845375 Z M12.5977073,9.79845375 C12.1566249,9.79845375 11.7979206,9.4397494 11.7979206,8.99866702 C11.7979206,8.55758464 12.1566249,8.1988803 12.5977073,8.1988803 C13.0387897,8.1988803 13.397494,8.55758464 13.397494,8.99866702 C13.397494,9.4397494 13.0385897,9.79845375 12.5977073,9.79845375 Z",
    fill: "url(#grad1)",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.34b31796.svg";
export { ForwardRef as ReactComponent };